var _defs, _tspan, _tspan2, _tspan3, _tspan4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "229.07495mm",
    height: "152.87503mm",
    viewBox: "0 0 229.07495 152.87503",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 284.99408,
    height: 140.96031,
    id: "rect34245-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 220.01994,
    height: 65.483643,
    id: "rect41764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 220.01994,
    height: 65.483643,
    id: "rect42718"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 220.01994,
    height: 65.483643,
    id: "rect42730"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-638.68147,-330.66744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer13",
    transform: "translate(565.00778,309.81883)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect39901",
    width: 219.07501,
    height: 142.875,
    x: 78.673698,
    y: 25.848608
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,71.612403,-40.873128)",
    id: "text34243-7",
    style: {
      fontSize: "106.667px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect34245-5)",
      shapePadding: 8.48528,
      display: "inline",
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 68.412109,
    y: 382.45616,
    id: "tspan56470"
  }, "BRB"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,190.28192,24.493196)",
    id: "text41762",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect41764)",
      shapePadding: 0.707103,
      display: "inline",
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56472"
  }, "H"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 96.639556,117.58637 H 110.19683",
    id: "path42433"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect34443-7",
    width: 49.346283,
    height: 12.225355,
    x: 234.81885,
    y: 52.799366
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 239.30629,126.64602 c -0.48355,0.95045 -1.02382,1.90763 -1.12253,2.99342 -0.11532,1.26852 -0.20263,2.79078 0.74835,3.74177 0.30514,0.30514 1.8811,-0.47963 2.05798,-0.56127 0.75968,-0.35062 1.5489,-0.65842 2.24506,-1.12253 0.93536,-0.62357 1.95852,-1.72761 2.99342,-2.24506 0.93977,-0.46989 3.21212,-1.34072 4.30304,-1.12254 1.48778,0.29756 1.30962,4.12444 1.30962,5.0514 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18709 0,0.18709 0.0624,0 -0.0279,-0.13131 0,-0.18709 0.10056,-0.20112 0.20612,-0.41189 0.37418,-0.56127 0.40096,-0.35641 0.91743,-0.5694 1.30962,-0.93545 0.54899,-0.51238 0.93545,-1.18489 1.49671,-1.68379 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92185 1.87088,3.18051 0.43731,0.6013 1.03152,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.5042 2.88136,-0.99924 4.30303,-0.74836 1.7318,0.30561 1.87761,0.85782 3.55469,1.49671 1.58486,0.60376 3.19072,0.93545 4.86431,0.93545",
    id: "path38892-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 239.30629,71.807001 c -0.48355,0.950454 -1.02382,1.907629 -1.12253,2.993419 -0.11532,1.268526 -0.20263,2.790788 0.74835,3.741774 0.30514,0.305139 1.8811,-0.479629 2.05798,-0.561266 0.75968,-0.35062 1.5489,-0.658423 2.24506,-1.122532 0.93536,-0.62357 1.95852,-1.727612 2.99342,-2.245066 0.93977,-0.469881 3.21212,-1.340715 4.30304,-1.122532 1.48778,0.297556 1.30962,4.124434 1.30962,5.051396 0,0.187087 0,0.374176 0,0.561267 0,0.0624 -0.0624,0.18709 0,0.18709 0.0624,0 -0.0279,-0.13131 0,-0.18709 0.10056,-0.201116 0.20612,-0.411883 0.37418,-0.561267 0.40096,-0.35641 0.91743,-0.569404 1.30962,-0.935445 0.54899,-0.512384 0.93545,-1.184894 1.49671,-1.683798 1.08123,-0.961096 4.69407,-3.554685 6.17393,-3.554685 0.19918,0 1.68277,2.921852 1.87088,3.180509 0.43731,0.601295 1.03152,0.983477 1.6838,1.309621 1.07587,0.537935 2.55027,-0.736221 3.55469,-1.122531 1.3109,-0.504196 2.88136,-0.999242 4.30303,-0.748356 1.7318,0.30561 1.87761,0.857819 3.55469,1.496708 1.58486,0.603756 3.19072,0.935445 4.86431,0.935445",
    id: "path41435"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 239.30629,85.829918 c -0.48355,0.950454 -1.02382,1.907629 -1.12253,2.993419 -0.11532,1.268526 -0.20263,2.790788 0.74835,3.741774 0.30514,0.305139 1.8811,-0.479629 2.05798,-0.561266 0.75968,-0.35062 1.5489,-0.658423 2.24506,-1.122532 0.93536,-0.62357 1.95852,-1.727612 2.99342,-2.245066 0.93977,-0.469881 3.21212,-1.340715 4.30304,-1.122532 1.48778,0.297556 1.30962,4.124434 1.30962,5.051396 0,0.187087 0,0.374176 0,0.561267 0,0.0624 -0.0624,0.18709 0,0.18709 0.0624,0 -0.0279,-0.13131 0,-0.18709 0.10056,-0.201116 0.20612,-0.411883 0.37418,-0.561267 0.40096,-0.35641 0.91743,-0.569404 1.30962,-0.935445 0.54899,-0.512384 0.93545,-1.184894 1.49671,-1.683798 1.08123,-0.961096 4.69407,-3.554685 6.17393,-3.554685 0.19918,0 1.68277,2.921852 1.87088,3.180509 0.43731,0.601295 1.03152,0.983477 1.6838,1.309621 1.07587,0.537935 2.55027,-0.736221 3.55469,-1.122531 1.3109,-0.504196 2.88136,-0.999242 4.30303,-0.748356 1.7318,0.30561 1.87761,0.857819 3.55469,1.496708 1.58486,0.603756 3.19072,0.935445 4.86431,0.935445",
    id: "path41437"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 239.30629,99.588256 c -0.48355,0.950444 -1.02382,1.907614 -1.12253,2.993414 -0.11532,1.26853 -0.20263,2.79079 0.74835,3.74178 0.30514,0.30514 1.8811,-0.47963 2.05798,-0.56127 0.75968,-0.35062 1.5489,-0.65842 2.24506,-1.12253 0.93536,-0.62357 1.95852,-1.72761 2.99342,-2.24507 0.93977,-0.46988 3.21212,-1.34072 4.30304,-1.12254 1.48778,0.29757 1.30962,4.12445 1.30962,5.05141 0,0.18709 0,0.37417 0,0.56127 0,0.0624 -0.0624,0.18709 0,0.18709 0.0624,0 -0.0279,-0.13131 0,-0.18709 0.10056,-0.20112 0.20612,-0.41189 0.37418,-0.56127 0.40096,-0.35641 0.91743,-0.56941 1.30962,-0.93545 0.54899,-0.51238 0.93545,-1.18489 1.49671,-1.68379 1.08123,-0.9611 4.69407,-3.5547 6.17393,-3.5547 0.19918,0 1.68277,2.92186 1.87088,3.18052 0.43731,0.60129 1.03152,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.5042 2.88136,-0.99924 4.30303,-0.74836 1.7318,0.30561 1.87761,0.85782 3.55469,1.49671 1.58486,0.60376 3.19072,0.93545 4.86431,0.93545",
    id: "path41439"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 239.30629,113.08201 c -0.48355,0.95045 -1.02382,1.90762 -1.12253,2.99342 -0.11532,1.26852 -0.20263,2.79078 0.74835,3.74177 0.30514,0.30514 1.8811,-0.47963 2.05798,-0.56127 0.75968,-0.35062 1.5489,-0.65842 2.24506,-1.12253 0.93536,-0.62357 1.95852,-1.72761 2.99342,-2.24506 0.93977,-0.46989 3.21212,-1.34072 4.30304,-1.12254 1.48778,0.29756 1.30962,4.12444 1.30962,5.0514 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18709 0,0.18709 0.0624,0 -0.0279,-0.13131 0,-0.18709 0.10056,-0.20112 0.20612,-0.41189 0.37418,-0.56127 0.40096,-0.35641 0.91743,-0.5694 1.30962,-0.93545 0.54899,-0.51238 0.93545,-1.18489 1.49671,-1.68379 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92185 1.87088,3.18051 0.43731,0.6013 1.03152,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.5042 2.88136,-0.99924 4.30303,-0.74836 1.7318,0.30561 1.87761,0.85782 3.55469,1.49671 1.58486,0.60376 3.19072,0.93545 4.86431,0.93545",
    id: "path41441"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,126.87272,24.744483)",
    id: "text42716",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect42718)",
      shapePadding: 0.707103,
      display: "inline",
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56474"
  }, "I\r\n"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,83.287783,24.995771)",
    id: "text42728",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect42730)",
      shapePadding: 0.707103,
      display: "inline",
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56476"
  }, "T\r\n"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 203.84136,117.58637 h 13.55727",
    id: "path43124"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 182.401,117.58637 h 13.55727",
    id: "path43126"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 160.96064,117.58637 h 13.55727",
    id: "path43128"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 139.52027,117.58637 h 13.55727",
    id: "path43130"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 118.07992,117.58637 h 13.55726",
    id: "path43132"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrb);
export default __webpack_public_path__ + "static/media/BRB.f3d278e573904b52cef0c423b2b72d6e.svg";
export { ForwardRef as ReactComponent };